import React, {useEffect, useState} from "react";
import Header from "./UserManagement/Header";
import Actions from "./UserManagement/Actions";
import ListOfBugs from "../../Componnets/BugReport/ListOfBugs";
import AddUserModal from "./UserManagement/AddUserModal";
import Styles from "./UserManagement/UserManagment.module.scss"
import {useHistory} from "react-router-dom";
import http from "../../../services/api/utilities/http";

const AdminPanel = () => {

  const [state, setState] = useState({
    filter: 1,
    showRemoveModal: false,
    showDataConnector: false,
    showDataConnectorVerification: false,
    verified: [],
    unverified: [],
    draft: [],
    uid: '',
    name: '',
    users: [],
    search: '',
    view: 'UserManagement',
  })
  const [addUserModal, setAddUserModal] = useState(false)
  const [pagination, setPagination] = useState({
    next: true,
    previous: false,
    page: 1,
    total_pages: 1,
  })
  const status = ['email_sent', 'verified', 'expired', 'pending']

  useEffect(() => {
    const el = document.querySelector("body")
    if (addUserModal) {
      const classString = el.className
      el.className = classString.concat(" overflow-hidden ")
    } else {
      el.className = el.className.replace(" overflow-hidden ", '');
    }
  }, [addUserModal])

  useEffect(() => {
    getUser(1)
  }, [])

  const history = useHistory()

  const getUser = (page = 1) => {
    const search = history.location.search && `&${history.location.search.substring(1)}`
    http.get('/authentication/user_management/?page=' + page + search)
      .then(res => {
        let users = res.data.data.results
        setState({...state, users})
        delete res.data.data.results
        setPagination(res.data.data)
      })
      .catch(err => {
        console.log(err.response)
      })
  }

  const {filter, draft, verified, unverified, search, view, users} = state;

  const formatLastLogin = (value) => {
    if (!value) return 'Never'

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value

    return new Intl.DateTimeFormat('en', {
      dateStyle: 'medium',
      timeStyle: 'short',
    }).format(date)
  }

  return (
    <div className={`data-pool flex-grow-1`}>
      <Header
        verified={verified.length}
        unverified={unverified.length}
        draft={draft.length}
        filter={filter}
        setFilter={filter => setState({...state, filter})}
        ShowDataConnector={() => setState({...state, showDataConnector: true})}
        search={search}
        getUser={getUser}
        setUser={users => setState({...state, users})}
        setView={view => setState({...state, view})}
        showAddUserModal={() => setAddUserModal(true)}
        view={view}
        setPagination={(pages) => setPagination(pages)}
      />

      <main className={[Styles.tableWrapper, "table table-select mt-24 d-flex justify-content-center admin-panel"].join(" ")}>
        {view === 'BUGS' ?
          <ListOfBugs search={search}/>
          :
          <table>
            <thead>
            <tr>
              <th>Username</th>
              <th className="wmc">Email</th>
              <th>Role</th>
              <th>Login Method</th>
              <th>Last Login</th>
              <th>Verification Status</th>
              <th className={Styles.actionsHeading}>Actions</th>
            </tr>
            </thead>
            <tbody>
            {users.map(user => (
              <tr key={user.id || user.username} className={user.is_active ? Styles.activeUser : Styles.deActiveUser}>
                <td>
                  <div className={Styles.userIdentity}>
                    <span className={Styles.userAvatar}>{(user.username || '?').trim().charAt(0).toUpperCase()}</span>
                    <span className={Styles.username}>{user.username}</span>
                  </div>
                </td>
                <td className="wmc">
                  <span className={Styles.email} title={user.email}>{user.email}</span>
                </td>
                <td><span className={Styles.roleBadge}>{user.role}</span></td>
                <td>
                  <span className={`${Styles.loginMethodBadge} ${(user.login_method || 'password').toLowerCase() === 'sso' ? Styles.ssoBadge : Styles.passwordBadge}`}>
                    {(user.login_method || 'password').toLowerCase() === 'sso' ? 'SSO' : 'Password'}
                  </span>
                </td>
                <td><span className={Styles.lastLogin}>{formatLastLogin(user.last_login)}</span></td>
                <td>
                  {
                    user.is_active ?
                      <div className={`${Styles.statusBadge} ${Styles[`status_${user.verification_status}`] || ''}`}>
                        {VerificationStatus(user.verification_status)}
                      </div>
                      :
                      <div className={`${Styles.statusBadge} ${Styles.status_deactivated}`}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_906_2133)">
                            <path d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61384 17.0484 4.32616 15.3611 2.63889C13.6738 0.951621 11.3862 0.00258081 9 0V0ZM9 1.5C10.7299 1.49862 12.4064 2.09831 13.743 3.1965L3.1965 13.743C2.29693 12.6449 1.72775 11.3138 1.55522 9.90482C1.38268 8.4958 1.6139 7.06676 2.22194 5.78403C2.82999 4.5013 3.78986 3.41766 4.98981 2.65923C6.18977 1.90081 7.58046 1.4988 9 1.5ZM9 16.5C7.27015 16.5014 5.59356 15.9017 4.257 14.8035L14.8035 4.257C15.7031 5.35512 16.2723 6.68616 16.4448 8.09518C16.6173 9.5042 16.3861 10.9332 15.7781 12.216C15.17 13.4987 14.2102 14.5823 13.0102 15.3408C11.8102 16.0992 10.4195 16.5012 9 16.5Z" fill="#374957"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_906_2133">
                              <rect width="18" height="18" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <p>Deactivated</p>
                      </div>
                  }
                </td>
                <td className={Styles.actionsCell}>
                  <div className={[!user.is_active && Styles.deActiveIcon, 'd-flex'].join(" ")}>
                    <Actions refreshList={getUser} user={user} openEditUser={() => setState({...state, openEditUser: true})}/>
                  </div>
                </td>
              </tr>
            ))}
            {!users.length && (
              <tr className={Styles.emptyRow}>
                <td colSpan="7">No users found.</td>
              </tr>
            )}
            </tbody>
            <tfoot></tfoot>
          </table>
        }
      </main>
      <Pagination pagination={pagination} setPagination={setPagination} getUsers={getUser}/>
      {addUserModal && <AddUserModal refreshList={getUser} closeEditUser={() => setAddUserModal(false)}/>}
    </div>
  )

}
export default AdminPanel;


const Pagination = ({pagination, setPagination, getUsers}) => {
  const pages = () => {
    let pages = [];
    for (let i = 1; i <= pagination.total_pages; i++) {
      pages.push(<div onClick={() => getUsers(i)}
                      className={[Styles.btn, pagination.page === i ? Styles.active : ''].join(' ')}>{i}</div>);
    }
    return pages;
  };

  return (
    <div className={Styles.paginationWrapper}>
      <div className={'d-flex'}>
        <div onClick={() => pagination.previous && getUsers(pagination.page - 1)}
             className={[Styles.btnArrow, pagination.previous ? Styles.active : ''].join(' ')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.53358 8.16753L13.5002 8.16753" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.53369 4.83353L2.24236 8.16753L7.53369 11.5015L7.53369 4.83353Z" stroke="#C2C7ED"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        {pages()}
        <div onClick={() => pagination.next && getUsers(pagination.page + 1)}
             className={[Styles.btnArrow, pagination.next ? Styles.active : ''].join(' ')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.46642 7.83247H2.49976" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.46631 11.1665L13.7576 7.83247L8.46631 4.49847V11.1665Z"
                  stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div className={Styles.paginationDescription}>
        Showing 10 of {pagination.count} Results
      </div>
    </div>
  )

}


const VerificationStatus = status => {
  return (
    status === 'verified' ?
      <>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
            stroke="#02DEAB" stroke-width="1.5"/>
          <path d="M9.25 11.75L11.25 13.75L14.75 10" stroke="#02DEAB" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
        <p className="fw300 f14 ml-2">Verified</p>
      </>
      :
      status === 'email_sent' ?
        <>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.88539 15.1513L3.61329 14.9705L2.88539 15.1513ZM2.88539 8.84875L3.61329 9.02949L2.88539 8.84875ZM21.1146 8.84875L21.8425 8.66801L21.1146 8.84875ZM21.1146 15.1512L20.3867 14.9705L21.1146 15.1512ZM15.1156 20.659L14.9533 19.9267H14.9533L15.1156 20.659ZM8.88443 20.659L9.04668 19.9267L8.88443 20.659ZM8.88443 3.34105L9.04668 4.07329L8.88443 3.34105ZM15.1156 3.34105L15.2778 2.60881V2.60881L15.1156 3.34105ZM8.43056 20.5584L8.2683 21.2906L8.43056 20.5584ZM15.5694 20.5584L15.7317 21.2906H15.7317L15.5694 20.5584ZM15.5694 3.44162L15.4072 4.17386V4.17386L15.5694 3.44162ZM8.43056 3.44162L8.2683 2.70938V2.70938L8.43056 3.44162ZM8.58712 9.73987C8.25008 9.49907 7.78166 9.57709 7.54087 9.91413C7.30008 10.2512 7.3781 10.7196 7.71513 10.9604L8.58712 9.73987ZM10.7216 12.1866L11.1576 11.5764L10.7216 12.1866ZM13.2783 12.1866L13.7143 12.7969H13.7143L13.2783 12.1866ZM16.2849 10.9604C16.6219 10.7196 16.6999 10.2512 16.4591 9.91413C16.2183 9.57709 15.7499 9.49907 15.4129 9.73987L16.2849 10.9604ZM8.59281 4.17386L9.04668 4.07329L8.72218 2.60881L8.2683 2.70938L8.59281 4.17386ZM14.9533 4.07329L15.4072 4.17386L15.7317 2.70938L15.2778 2.60881L14.9533 4.07329ZM15.4072 19.8261L14.9533 19.9267L15.2778 21.3912L15.7317 21.2906L15.4072 19.8261ZM9.04668 19.9267L8.59281 19.8261L8.2683 21.2906L8.72218 21.3912L9.04668 19.9267ZM3.61329 14.9705C3.1289 13.0198 3.1289 10.9802 3.61329 9.02949L2.1575 8.668C1.61417 10.8561 1.61417 13.1439 2.1575 15.332L3.61329 14.9705ZM20.3867 9.0295C20.8711 10.9802 20.8711 13.0198 20.3867 14.9705L21.8425 15.332C22.3858 13.1439 22.3858 10.8561 21.8425 8.66801L20.3867 9.0295ZM14.9533 19.9267C13.008 20.3578 10.992 20.3578 9.04668 19.9267L8.72218 21.3912C10.8812 21.8696 13.1188 21.8696 15.2778 21.3912L14.9533 19.9267ZM9.04668 4.07329C10.992 3.64224 13.008 3.64224 14.9533 4.07329L15.2778 2.60881C13.1188 2.1304 10.8812 2.1304 8.72218 2.60881L9.04668 4.07329ZM8.59281 19.8261C6.14627 19.284 4.21736 17.4032 3.61329 14.9705L2.1575 15.332C2.89874 18.3171 5.26576 20.6253 8.2683 21.2906L8.59281 19.8261ZM15.7317 21.2906C18.7342 20.6253 21.1013 18.3171 21.8425 15.332L20.3867 14.9705C19.7826 17.4032 17.8537 19.284 15.4072 19.8261L15.7317 21.2906ZM15.4072 4.17386C17.8537 4.71598 19.7826 6.5968 20.3867 9.0295L21.8425 8.66801C21.1013 5.68288 18.7342 3.3747 15.7317 2.70938L15.4072 4.17386ZM8.2683 2.70938C5.26576 3.3747 2.89874 5.68288 2.1575 8.668L3.61329 9.02949C4.21736 6.59679 6.14627 4.71598 8.59281 4.17386L8.2683 2.70938ZM7.71513 10.9604L10.2857 12.7969L11.1576 11.5764L8.58712 9.73987L7.71513 10.9604ZM13.7143 12.7969L16.2849 10.9604L15.4129 9.73987L12.8424 11.5764L13.7143 12.7969ZM10.2857 12.7969C11.3112 13.5295 12.6888 13.5295 13.7143 12.7969L12.8424 11.5764C12.3384 11.9364 11.6616 11.9364 11.1576 11.5764L10.2857 12.7969Z"
              fill="#FFC700"/>
          </svg>
          <p className="fw300 f14 ml-2">Email Sent</p>
        </>
        : status === 'pending' ?
        <>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
              stroke="#70789E" stroke-width="1.5"/>
            <path d="M14.5002 14.5L11.6616 12.6939V9" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
          <p className="fw300 f14 ml-2">Pending</p>
        </>
        :
        <>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
              stroke="#FF0053" stroke-width="1.5"/>
            <path d="M13.768 10.2322L10.2324 13.7678M13.768 13.7678L10.2324 10.2322" stroke="#FF0053" stroke-width="1.5"
                  stroke-linecap="round"/>
          </svg>
          <p className="fw300 f14 ml-2">Expired</p>
        </>

  )
}
